export default "__VITE_ASSET__D$D$1RkY__"